module.exports = __webpack_public_path__ + "static/img/news63.ca75870.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news63.png
// module id = 9m6X
// module chunks = 0